import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Landing from "@/pages/Landing";
import Pricing from "@/pages/Pricing";
import Contact from "@/pages/Contact";
import Calculator from "@/pages/Calculator";
import Services from "@/pages/Services";
import AiAgents from "@/pages/services/AiAgents";
import LeadGeneration from "@/pages/services/LeadGeneration";
import ExecutiveAssistants from "@/pages/services/ExecutiveAssistants";
import RfpVendorRegistration from "@/pages/services/RfpVendorRegistration";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/calculator" element={<Calculator />} />
          <Route path="/services" element={<Services />} />
          <Route path="/services/ai-agents" element={<AiAgents />} />
          <Route path="/services/lead-generation" element={<LeadGeneration />} />
          <Route path="/services/executive-assistants" element={<ExecutiveAssistants />} />
          <Route path="/services/rfp-vendor-registration" element={<RfpVendorRegistration />} />
          <Route path="*" element={<Landing />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
